enum IMAGEAPI_TYPE {
  PersonalInfo = 1,
  Reviews = 2,
  FeedBack = 3,
  AfterSale = 4,
}

export default IMAGEAPI_TYPE;